import { DialogComponent } from '@theme/dialog';

class ShareProductDialog extends DialogComponent {
  async copyLink(event) {
    event.preventDefault();

    const shareUrl = this.dataset.shareUrl;
    if (!shareUrl) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        this.#copyWithTextarea(shareUrl);
      }

      this.#showCopiedState();
    } catch (error) {
      this.#copyWithTextarea(shareUrl);
      this.#showCopiedState();
    }
  }

  #copyWithTextarea(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';

    document.body.append(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  }

  #showCopiedState() {
    const copyButtonLabel = this.refs.copyButtonLabel;
    if (!(copyButtonLabel instanceof HTMLElement)) return;

    copyButtonLabel.textContent = this.dataset.copiedText || 'COPIED';
    clearTimeout(this.copyResetTimer);

    this.copyResetTimer = setTimeout(() => {
      copyButtonLabel.textContent = this.dataset.copyText || 'COPY LINK';
    }, 1600);
  }
}

if (!customElements.get('share-product-dialog')) {
  customElements.define('share-product-dialog', ShareProductDialog);
}
